// @ts-check
import { roundToDecimal } from './decimals'
import { toNumber } from './numbers'

/**
 * @param {number} [mins]
 * @returns {number}
 */
export const toAnesthesiaUnits = mins => roundToDecimal(toNumber(mins) / 15, 1)
